import { formatMoney } from "@/lib/format";
import type { Money } from "@/lib/shopify/types";

type Props = { price: Money; maxPrice?: Money; compareAtPrice?: Money | null; trimZeros?: boolean };

export function Price({ price, maxPrice, compareAtPrice, trimZeros = true }: Props) {
  const isRange = maxPrice && Number(maxPrice.amount) > Number(price.amount);
  return (
    <span className="tabular-nums">
      {isRange ? "From " : ""}
      {formatMoney(price, { trimZeros })}
      {compareAtPrice ? (
        <>
          {" "}
          <s className="text-paper">
            <span className="sr-only">Was </span>
            {formatMoney(compareAtPrice, { trimZeros })}
          </s>
        </>
      ) : null}
    </span>
  );
}
